<mat-form-field style="width: 100%">
    <mat-label>Project Nr.</mat-label>
    <input matInput type="text" [formControl]="formControl" [matAutocomplete]="auto" [required]="!!required"/>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (budget of budgetsList; track budget) {
            <mat-option [value]="budget">
                {{ budget.project.projectNr }} ({{ budget.budgetNr }})
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
